import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  searchIcon: {
    color: "grey"
  },
  gridItemEnd: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  typography: {
    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%;" /* 24px */,
    letterSpacing: "0.15px",
  },
  topPadding: {
    marginTop: '24px',
  },
  searchBar: {
    display: "flex",
    width: "466px",
    flexDirection: "column",
    "& .MuiInputBase-root": {
      height: "40px",
      padding: "0 12px",
    }
  },
  mainContainer: {
    display: "flex",
    marginTop: "24px",
    gap: "20px",
  },
  marginBotton: {
    marginBottom: "24px"
  },
  searchTypography: {
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px", /* 150% */
    letterSpacing: "0.15px",
  },
  switch: {
    marginLeft: 10,
    whiteSpace: 'nowrap', // Default to nowrap for larger screens
  },
  // Media query for screens less than or equal to 1660px
  '@media (max-width: 1660px)': {
    switch: {
      whiteSpace: 'normal', 
    },
  },
  teamFilterWrapper: {
    display: "flex",
    alignItems: "center",
    '& .MuiInputBase-root': {
      height: "40px !important",
    }
  },
  itemEnd: {
    marginLeft: "auto",
  },
}));